"use strict";

(function() {

	/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
	/* (or just for speeding up the editing interface where we don't need lots of the interactivity) */
	/* Note: if many pages need cleaning up, it can be a solution to put in a script that is loaded in edit mode (eg link target, nbsp, empty tags) */
	if (!(document.querySelector("body").classList.contains("isEditing"))) {

		// FAQ structured data snippet
		// TODO: add more structured data
		if (document.querySelector(".hb-accordion--linje")) {
			const faqdata = {
				"@context": "https://schema.org",
				"@type": "FAQPage",
				"mainEntity": []
			};
			const faqentries = document.querySelectorAll(".hb-accordion--linje .accordion");
			for (let i = 0; i < faqentries.length; i++) {
				faqdata.mainEntity.push({
					"@type": "Question",
					"name": faqentries[i].querySelector(".dcl-trigger").innerText,
					"acceptedAnswer": {
						"@type": "Answer",
						"text": faqentries[i].querySelector(".dcl-content").innerHTML
					}
				});
			}
			const script = document.createElement("script");
			script.setAttribute("type","application/ld+json");
			script.textContent = JSON.stringify(faqdata);
			document.head.appendChild(script);
		}

	}

})();
